module.exports = __webpack_public_path__ + "img/DisplayX19320.553a1a05.svg";